import { render, staticRenderFns } from "./Buyerss.vue?vue&type=template&id=0bfa8094&"
import script from "./Buyerss.vue?vue&type=script&lang=js&"
export * from "./Buyerss.vue?vue&type=script&lang=js&"
import style0 from "./Buyerss.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports